export default __webpack_public_path__ + "static/media/forest-image.aeefbd9c.png";